import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

/**
 * SubscriptionHistoryTable
 * Lists plan assignment (subscription) log entries for the business.
 *
 * Props:
 *  - logs: Array<{
 *      id: string,
 *      dateTime: string,          // pre-formatted display string
 *      planName: string,
 *      interpretationLimit: string|number,
 *      centerLimit: string|number,
 *      userLimit: string|number,
 *      assignedBy: string,
 *    }>
 *  - loading: boolean
 */

const columns = [
  { key: "dateTime", label: "Date & Time" },
  { key: "planName", label: "Plan Name" },
  { key: "interpretationLimit", label: "Interpretation Limit" },
  { key: "centerLimit", label: "Center Limit" },
  { key: "userLimit", label: "User Limit" },
  { key: "assignedBy", label: "Assigned By" },
];

const SubscriptionHistoryTable = ({ logs = [], loading = false }) => {
  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        border: "1px solid #e2e0ed",
        borderRadius: "14px",
        overflow: "hidden",
      }}
    >
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              {columns.map((col) => (
                <TableCell
                  key={col.key}
                  sx={{
                    backgroundColor: "#f8f7fc",
                    fontSize: "11px",
                    fontWeight: 700,
                    letterSpacing: "0.04em",
                    color: "#66647a",
                    textTransform: "uppercase",
                    borderBottom: "1px solid #e2e0ed",
                    padding: "12px 20px",
                  }}
                >
                  {col.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {logs.map((log) => (
              <TableRow key={log.id}>
                <TableCell
                  sx={{
                    fontSize: "14px",
                    color: "#22223b",
                    borderBottom: "1px solid #efeef5",
                    padding: "16px 20px",
                  }}
                >
                  {log.dateTime}
                </TableCell>

                <TableCell
                  sx={{
                    fontSize: "14px",
                    fontWeight: 600,
                    color: "#22223b",
                    borderBottom: "1px solid #efeef5",
                    padding: "16px 20px",
                  }}
                >
                  {log.planName}
                </TableCell>

                <TableCell
                  sx={{
                    fontSize: "14px",
                    color: "#22223b",
                    borderBottom: "1px solid #efeef5",
                    padding: "16px 20px",
                  }}
                >
                  {log.interpretationLimit}
                </TableCell>

                <TableCell
                  sx={{
                    fontSize: "14px",
                    color: "#22223b",
                    borderBottom: "1px solid #efeef5",
                    padding: "16px 20px",
                  }}
                >
                  {log.centerLimit}
                </TableCell>

                <TableCell
                  sx={{
                    fontSize: "14px",
                    color: "#22223b",
                    borderBottom: "1px solid #efeef5",
                    padding: "16px 20px",
                  }}
                >
                  {log.userLimit}
                </TableCell>

                <TableCell
                  sx={{
                    fontSize: "14px",
                    color: "#4c4a5c",
                    borderBottom: "1px solid #efeef5",
                    padding: "16px 20px",
                  }}
                >
                  {log.assignedBy}
                </TableCell>
              </TableRow>
            ))}

            {!loading && logs.length === 0 && (
              <TableRow>
                <TableCell
                  colSpan={columns.length}
                  sx={{
                    textAlign: "center",
                    padding: "32px 20px",
                    fontSize: "14px",
                    color: "#999",
                    borderBottom: "none",
                  }}
                >
                  No subscription history yet
                </TableCell>
              </TableRow>
            )}

            {loading && (
              <TableRow>
                <TableCell
                  colSpan={columns.length}
                  sx={{
                    textAlign: "center",
                    padding: "32px 20px",
                    fontSize: "14px",
                    color: "#999",
                    borderBottom: "none",
                  }}
                >
                  Loading...
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default SubscriptionHistoryTable;
